import { DOCUMENTO_LIQUIDACION_TYPES } from "../constants/documento-liquidacion.types";
import { ActionDL, DocumentoLiquidacion, StateDL } from "../interfaces/documento-liquidacion.interfaces";

const initialState: DocumentoLiquidacion = {
    formCliente: {
        granContribuyente: false,
        fecha: new Date().toISOString().split('T')[0],
        tipoEstablecimiento: '',
        tipoDocumento: '36',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',
    
        datosSucursal: [],
        datosDocumento: [],
    
        sucursal: '',
        serie:'',
        loadedSucursal: false,
    },

    formLiquidador: {
        fechaInicio: '',
        fechaFin: new Date().toISOString().split('T')[0],
        montoOperaciones: '',
        cantidadDocumentos: '',
        tipoComision: 'Porcentaje',
        comision: '',
        observaciones: '',
        montoSinPercepcion: ''
    },
    errorsLiquidador: {
        fechaInicio: '',
        fechaFin: '',
        montoOperaciones: '',
        cantidadDocumentos: '',
        tipoComision: '',
        comision: '',
        observaciones: '',
        montoSinPercepcion: ''
    },

    errorsCliente: {
        granContribuyente: false,
        fecha: '',
        tipoDocumento: '',
        noDocumento: '',
        nombre: '',
        departamento: '',
        municipio: '',
        direccion: '',
        email: '',
        chipsEmail: [],
        telefono: '',
        actividad: '',
        actividadDescripcion: '',
        municipioDescripcion: '',
        departamentoDescripcion: '',
        nrc: '',
    
        datosSucursal: null,
        datosDocumento: null,
    
        sucursal: '',
        serie:'',
        tipoEstablecimiento: ''
    },

    productos: [],
    formProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        unidadMedida: '59'
    },

    errorsProducto: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: '',
        descuento: '',
        servicio: false,
        exento: false,
        unidadMedida: ''
    },
    modal_editar: false,
    modal_eliminar: false,
    modal_quitarTodo: false,
    modal_emitir: false,
    modal_emitido: false,
    modal_masOpciones: false,
    modal_enviarCorreo: false,
    modal_imprimir: false,
    modal_anular: false,
    modal_anulado: false,
    modal_clienteEncontrado: false,

    clienteEncontrado: null,
    productoEdit: {
        conIva: false,
        descripcion: '',
        cantidad: '',
        precio: '',
        tipoDescuento: 'Porcentaje',
        descuento: '',
        servicio: false,
        exento: false,
        unidadMedida: ''
    },
    productoIndex: null,

    calculosGenerales: {
        operaciones: '',
        retencionRenta: '',
        iva: '',
        ivaPercibido: '',
        ivaRenetido: '',
    },

    calculosProducto: {
        neto: '',
        subtotal: '',
        descuento: '',
        total: '',
        iva: ''
    },

    view: 'Formularios',
    
    response_Emitir: null,
    response_QRcode: '',
    sucursales: [],
    documentos: [],
    tableProductos: [],
    retencionRenta: false
}

const documentoLiquidacionReducer = (
    state: DocumentoLiquidacion = initialState,
    action: ActionDL
): StateDL => {
    switch (action.type) {
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_FORM_CLIENTE:
            return {...state, formCliente: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_FORM_PRODUCTO:
            return {...state, formProducto: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_HANDLE_ERRORS_CLIENTE:
            return {...state, errorsCliente: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_HANDLE_ERRORS_PRODUCTO:
            return {...state, errorsProducto: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_VIEW:
            return {...state, view: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_PRODUCTOS:
            return {...state, productos: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_PRODUCTO_EDIT:
            return {...state, productoEdit: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_PRODUCTO_INDEX:
            return {...state, productoIndex: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_EDITAR_PRODUCTO:
            return {...state, modal_editar: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_ELIMINAR_PRODUCTO:
            return {...state, modal_eliminar: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_QUITAR_TODO:
            return {...state, modal_quitarTodo: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_EMITIR:
            return {...state, modal_emitir: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_EMITIDO:
            return {...state, modal_emitido: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_MAS_OPCIONES:
            return {...state, modal_masOpciones: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_ENVIAR_CORREO:
            return {...state, modal_enviarCorreo: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_ANULAR:
            return {...state, modal_anular: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_ANULADO:
            return {...state, modal_anulado: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_IMPRIMIR:
            return {...state, modal_imprimir: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_CALCULOS_GENERALES:
            return {...state, calculosGenerales: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_RESTART_FORM_PRODUCTO:
            return {...state, formProducto: initialState.formProducto}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_QR_CODE:
            return {...state, response_QRcode: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_RESPONSE_EMITIR:
            return {...state, response_Emitir: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_CLIENTE_ENCONTRADO:
            return {...state, clienteEncontrado: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_ACTIVE_MODAL_CLIENTE_ENCONTRADO:
            return {...state, modal_clienteEncontrado: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_CALCULOS_PRODUCTO:
            return {...state, calculosProducto: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_TABLE_PRODUCTOS:
            return {...state, tableProductos: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_RETENCION_RENTA:
            return {...state, retencionRenta: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_SET_FORM_LIQUIDADOR:
            return {...state, formLiquidador: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_HANDLE_ERRORS_LIQUIDADOR:
            return {...state, errorsLiquidador: action.payload}
        case DOCUMENTO_LIQUIDACION_TYPES.DL_RESTART_ALL:
            return {...initialState, productos: [], formCliente: initialState.formCliente}
        default:
            return state;
    }
}

export default documentoLiquidacionReducer;